var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-form-group',[_c('b-form-input',{attrs:{"placeholder":"E-Posta Konusu"},model:{value:(_vm.dataItem.email_subject),callback:function ($$v) {_vm.$set(_vm.dataItem, "email_subject", $$v)},expression:"dataItem.email_subject"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }